/**
 * AnalystRoute — Route guard for analyst-only pages.
 *
 * Requires the user to be authenticated AND (isAnalyst OR isBatman).
 * Used for the /analyst cross-org dashboard route.
 * Does NOT depend on OrganizationContext or orgSlug (unlike ProtectedRoute).
 */

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function AnalystRoute() {
  const { isAuthenticated, isAnalyst, isAnalystResolved, isBatman, isBatmanResolved, hasSession } = useAuth();

  // Not authenticated — redirect to login
  if (hasSession === false) {
    return <Navigate to="/login" replace />;
  }

  // Still resolving auth — show spinner
  if (!isAnalystResolved || !isBatmanResolved) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Authenticated but not analyst or batman — redirect to home
  if (isAuthenticated && !isAnalyst && !isBatman) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
